"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getLayerMetadataFile = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getLayerMetadataFile = function getLayerMetadataFile(url) {
  return _axios.default.get(url).then(function (response) {
    return response.data.muni_map;
  });
};

exports.getLayerMetadataFile = getLayerMetadataFile;
var _default = getLayerMetadataFile;
exports.default = _default;